import React from "react";
import {Circles} from "react-loader-spinner";

import classes from "./BodyLoader.module.css";

const BodyLoader = ({title}) => {
  return (
    <div className={classes?.bodyLoader}>
      <Circles color="#fff" height={120} width={120} />
      {title && <h1>{title}</h1>}
    </div>
  );
};

export default BodyLoader;
